<template>

  <div>

    <div class="block__wrapper">

      <div class="block__content">

        <div class="column--left hideMobile">

          <h1>Amiraali Ahtio & Lemmen airue</h1>

        </div>

        <div class="column--right">

          <p>
             Amiraali Ahtio & Lemmen airue on helsinkiläinen bilebändi, joka tekee
            juhlistasi täydelliset. Kun otat meihin yhteyttä, riittää että tiedät
            juhliesi päivämäärän ja sijainnin: me jatkamme siitä.
          </p>

          <p>Pyydä tarjous yhteydenottolomakkeella.</p>

          <div><a href="#" v-scroll-to="'#contact'">Ota yhteyttä</a></div>

          <div class="marginTop--extrasmall">

            <a href="#" v-scroll-to="'#faq'">Usein kysytyt kysymykset</a>

          </div>

          <p data-v-0abcaef8="" class="marginTop--medium">Amiraali somessa:</p>

          <a
            data-v-0abcaef8=""
            href="https://www.facebook.com/amiraaliahtio/"
            target="_blank"
          >
            <img data-v-0abcaef8="" src="../assets/fb.png" class="icon" />
          </a>

          <a
            data-v-0abcaef8=""
            href="https://www.instagram.com/amiraaliahtio/"
            target="_blank"
          >
            <img
              data-v-0abcaef8=""
              src="../assets/instagram.svg"
              class="icon marginLeft--extrasmall"
            />
          </a>

        </div>

      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: "block1",
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1:first-child {
  margin-top: 0;
}

.block__wrapper {
  margin-top: -15vh;
  width: 100%;
  min-height: 100vh;
  background: none;
  position: relative;
}
.block__clip {
  -webkit-clip-path: polygon(50% 100%, 0 0, 100% 0);
  clip-path: polygon(50% 100%, 0 0, 100% 0);
  background: var(--color-text);
  position: absolute;
  width: 75vw;
  height: 75px;
  margin: auto;
}
.block__content {
  -webkit-clip-path: polygon(50% 7%, 100% 0, 100% 100%, 0 100%, 0 0);
  clip-path: polygon(50% 7%, 100% 0, 100% 100%, 0 100%, 0 0);
  background: var(--lighter-background);
  width: 75vw;
  margin: auto;
  min-height: 75vh;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
}

.column--left {
  width: 50%;
  margin-top: -20%;
  padding: 4rem;
}
.column--right {
  width: 50%;
  padding: 4rem;
}
.icon {
  height: 2rem;
}

@media (max-width: 900px) {
  .block__wrapper {
    margin-top: 0rem;
  }
  .block__content {
    width: 100%;
    background: none;
    text-align: center;
    padding: 2rem;
  }
  .column--left {
    width: 100%;
    margin-top: 2rem;
    padding: 0;
  }
  .column--right {
    width: 100%;
    padding: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Block1.vue